import { shallowRef } from 'vue'

import type { BasemapKind } from '@/components/map/mapMode'
import { useUserLocation } from '@/composables/useUserLocation'

/**
 * State behind `MapControls`: which basemap a map is drawing, and the user's
 * position. Every screen with a map calls this once and hands the result
 * straight to `<MapControls>` and `<MapView>`.
 *
 * Per-call, not a singleton. Each screen owns its own map, and a shared
 * `location` would mean one screen's locate press flew another screen's camera
 * the next time it was shown.
 *
 * `basemap` is local UI state and deliberately not routed: it is a view
 * preference, and putting it in the URL would make the back gesture undo a
 * satellite toggle.
 */
export function useMapControls() {
  const basemap = shallowRef<BasemapKind>('map')
  const { location, isLocating, error, locate } = useUserLocation()

  function toggleBasemap() {
    basemap.value = basemap.value === 'map' ? 'satellite' : 'map'
  }

  return { basemap, toggleBasemap, location, isLocating, error, locate }
}
